import PropTypes from 'prop-types';
import React from 'react';
import {
  withStyles,
  Popover,
  Typography,
  CircularProgress,
  Divider,
} from '@material-ui/core';

import CheckIcon from '@material-ui/icons/CheckCircle';
import green from '@material-ui/core/colors/green';
import ErrorIcon from '@material-ui/icons/HighlightOff';
import red from '@material-ui/core/colors/red';
import LensIcon from '@material-ui/icons/Lens';
import grey from '@material-ui/core/colors/grey';

import styles from './styles';

export const UI_DELIVERY_METHOD = 'ui';
export const EMAIL_DELIVERY_METHOD = 'email';
export const MOBILE_DELIVERY_METHOD = 'mobile';
export const SLACK_DELIVERY_METHOD = 'slack';

export const unknownIcon = (
  <LensIcon
    style={{ color: grey[400] }}
  />
);
export const coveredIcon = (
  <CheckIcon
    style={{ color: green[400] }}
  />
);
export const uncoveredIcon = (
  <ErrorIcon
    style={{ color: red[400] }}
  />
);

export const getUserSubscriptionName = (userSubscription) => {
  switch (userSubscription.type) {
    case UI_DELIVERY_METHOD:
      return 'In App';
    case EMAIL_DELIVERY_METHOD:
      return 'Email';
    case MOBILE_DELIVERY_METHOD:
      return <span>Mobile <br /> {userSubscription.deviceName && `(${userSubscription.deviceName})`}</span>;
    case SLACK_DELIVERY_METHOD:
      return 'Slack';
    default:
      return 'Unknown';
  }
};

export const getSubscriptionIcon
  = (eventType, subscription, disabledNotifications) => {
    if (!subscription) {
      return unknownIcon;
    }

    if (
      disabledNotifications
        || subscription.optOuts.indexOf(eventType) >= 0
    ) {
      return uncoveredIcon;
    }

    return coveredIcon;
  };

const UserEventSubscriptionPopover = ({
  classes,
  subscriptionAnchorEl,
  onClose,
  userSubscription,
  isFetchingUserSubscription,
  eventTypes,
}) => (
  <Popover
    id="simple-popper"
    open={Boolean(subscriptionAnchorEl)}
    anchorEl={subscriptionAnchorEl}
    onClose={onClose}
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
  >
    <div className={classes.container}>
      <Typography variant="h5" gutterBottom>
        When <b>{userSubscription.email}</b> will be notified
      </Typography>
      <Divider />
      {
        !isFetchingUserSubscription && userSubscription.disableNotifications
        && (
          <Typography variant="h5" color="error" gutterBottom>
            This user has turned off notifications
          </Typography>
        )
      }
      {
         isFetchingUserSubscription
           ? <div style={{ textAlign: 'center' }}><CircularProgress /></div>
           : (
             <table className={classes.notificationTable}>
               <tbody>
                 <tr key="event-type-group">
                   <td />
                   {
                    userSubscription.subscriptions
                      && userSubscription.subscriptions.map((subscription) => (
                        <td
                          key={subscription.type + +subscription.deviceId}
                          style={{
                            textAlign: 'center',
                            width: 60,
                          }}
                        >
                          {getUserSubscriptionName(subscription)}
                        </td>
                      ))
                  }
                 </tr>
                 {(eventTypes.filter((et) => et.group === 'events')).map((eventType) => (
                   <tr key={eventType.eventType}>
                     <td>
                       {eventType.displayName}
                     </td>
                     {
                      userSubscription.subscriptions
                        && userSubscription.subscriptions.map((subscription) => (
                          <td className={classes.tableCell} key={eventType.eventType + subscription.type}>
                            {getSubscriptionIcon(
                              eventType.eventType,
                              subscription,
                              userSubscription.disableNotifications,
                            )}
                          </td>
                        ))
                    }
                   </tr>
                 ))}
               </tbody>
             </table>
           )
      }

    </div>
  </Popover>
);

UserEventSubscriptionPopover.propTypes = {
  classes: PropTypes.object,
  subscriptionAnchorEl: PropTypes.object,
  onClose: PropTypes.func,
  userSubscription: PropTypes.object,
  isFetchingUserSubscription: PropTypes.bool,
  eventTypes: PropTypes.array,
};

UserEventSubscriptionPopover.defaultProps = {
  classes: {},
  subscriptionAnchorEl: null,
  onClose: () => {},
  userSubscription: { disableNotifications: false },
  isFetchingUserSubscription: true,
  eventTypes: [],
};

export default withStyles(styles)(UserEventSubscriptionPopover);
